import React, { useState } from "react";
import { useAppSelector } from "../../../../../../app/hooks";
import { useMyProfileQuery } from "../../../../../../services/profileService/profile-api";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  TextField,
} from "@mui/material";
import { RestartAlt } from "@mui/icons-material";
import {
  useVarianceReopenMutation,
} from "../../../../../../services/varianceService/variance-api";
import { VarianceReopenPostCommand } from "../../../../../../services/varianceService/commands/VarianceReopenPostCommand";

type ownProps = {
  setNotify: Function;
  setMessage: Function;
};

function VarianceReopenBtn(props: ownProps) {
  const variance = useAppSelector(
    (state) => state.varianceRequest.varianceRequest
  );
  const myProfile = useMyProfileQuery();
  const [reopen, result] = useVarianceReopenMutation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [reason, setReason] = useState("");

  const handleReopen = async () => {
    if (!variance?.id || !myProfile.data?.identity || !myProfile.data?.email) {
      console.error("Missing required data for reopen");
      return;
    }
    try {
      const command = new VarianceReopenPostCommand(
        variance.id,
        myProfile.data.identity,
        myProfile.data.email,
        reason
      );
      await reopen(command).unwrap();
      setDialogOpen(false);
      setReason("");
      props.setNotify(true);
      props.setMessage("Incident Reopened");
    } catch (error) {
      console.error("Failed to reopen incident:", error);
    }
  };

  return (
    <React.Fragment>
      <Button
        variant="outlined"
        color="warning"
        startIcon={<RestartAlt />}
        onClick={() => setDialogOpen(true)}
      >
        Reopen Incident
      </Button>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Reopen Incident</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to reopen this incident? It will return to
            &quot;In Progress&quot; status and go through the full workflow again.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Reason for reopening"
            fullWidth
            multiline
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleReopen} color="warning" variant="contained">
            Reopen
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={result.isError}>
        <Alert color="error">
          {"An error has occured: " + JSON.stringify(result.error)}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
}

export { VarianceReopenBtn };
